import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import * as React from 'react'
import styled from 'styled-components'

// Make typescript happy
declare var $: any

// tslint:disable-next-line:no-empty-interface
interface IProps {
  id: string
  fromId: string
  fromOffset: number
  toId: string
  toOffset: number
}

@observer
export class IntakeScaleBar extends React.Component<IProps> {
  @observable private visible = false

  public componentDidMount() {
    window.addEventListener('scroll', () => { this.visible = this.shouldBeVisible() })
  }

  public render() {
    const barVisibility = this.visible ? 'visible' : 'hidden'
    return(
      <Bar id={this.props.id} style={{visibility:barVisibility}}>
        {this.props.children}
      </Bar>
    )
  }

  private shouldBeVisible = () => {
    // detect which scale bar to use and get its height
    const intakeScaleBar = this.props.fromId === 'intake-step-7' ?
      document.querySelector('#intake-scale-1') :
      document.querySelector('#intake-scale-2')

    let intakeScaleBarHeight = 0
    if (intakeScaleBar) {
      intakeScaleBarHeight = intakeScaleBar!.getBoundingClientRect().height
    }

    try {
      // get y coord of top of first question to show bar
      const fromElems = $('#' + this.props.fromId)
      const fromElem = fromElems[0]
      const fromBounds = fromElem.getBoundingClientRect()
      const fromTop = fromBounds.top

      // hide bar if before first question (10 px added for rounding of small devices)
      if (fromTop - 10 > this.props.fromOffset + intakeScaleBarHeight) { return false }

      // get y coord of top of last question to show bar
      const toElems = $('#' + this.props.toId)
      const toElem = toElems[0]
      const toBounds = toElem.getBoundingClientRect()
      const toTop = toBounds.top

      // hide bar if after the last question
      if (toTop < this.props.toOffset + intakeScaleBarHeight) { return false }

    } catch (e) {
      return false
    }

    return true
  }
}

export const Bar = styled.div`
  min-height: 70px;
  background: #0F3252;
  position: fixed;
  margin-top: env(safe-area-inset-top);
  top: 134px;
  left: 0;
  right: 0;
  z-index: 5;
`



// WEBPACK FOOTER //
// ./src/organisms/Intakes/IntakeScaleBar.tsx